export enum RoleEnum {
    reporter = 'Reporter',
    verifier = 'Verifier',
    admins = 'Admins',
    programAdmin = 'Program_Admin',
    systemAdmin = 'System_Admin'
}
